import type {FabricSampleSelection} from '../types/fabricSample';
import { create } from 'zustand';
import type { ModelEdition } from '../components/common/ModelVersionControl';

interface FabricDisplayState {
  fabricFile: string | null;
  fabricSample: FabricSampleSelection | null;
  setFabricSample: (selection:FabricSampleSelection|null)=>void;
  selectedStyleId: string | null;
  selectedCategory: string;
  selectedAspectKey: string;
  selectedResolution: string;
  selectedModelEdition: ModelEdition;
  customPromptText: string;
  activeTaskIds: string[];
  setFabricFile: (path: string | null) => void;
  setSelectedStyleId: (id: string | null) => void;
  setSelectedCategory: (category: string) => void;
  setSelectedAspectKey: (key: string) => void;
  setSelectedResolution: (resolution: string) => void;
  setSelectedModelEdition: (edition: ModelEdition) => void;
  setCustomPromptText: (text: string) => void;
  setActiveTaskIds: (ids: string[] | ((current: string[]) => string[])) => void;
  reset: () => void;
}

const initialState = {
  fabricFile: null,
  fabricSample:null as FabricSampleSelection|null,
  selectedStyleId: null,
  selectedCategory: 'all',
  selectedAspectKey: '1:1',
  selectedResolution: '1K',
  selectedModelEdition: 'auto' as ModelEdition,
  customPromptText: '',
  activeTaskIds: [] as string[],
};

export const useFabricDisplayStore = create<FabricDisplayState>((set) => ({
  ...initialState,
  setFabricSample:(fabricSample)=>set({fabricSample}),
  setFabricFile: (fabricFile) => set({ fabricFile,fabricSample:null }),
  setSelectedStyleId: (selectedStyleId) => set({ selectedStyleId,fabricSample:null }),
  setSelectedCategory: (selectedCategory) => set({ selectedCategory }),
  setSelectedAspectKey: (selectedAspectKey) => set({ selectedAspectKey }),
  setSelectedResolution: (selectedResolution) => set({ selectedResolution }),
  setSelectedModelEdition: (selectedModelEdition) => set({ selectedModelEdition }),
  setCustomPromptText: (customPromptText) => set({ customPromptText }),
  setActiveTaskIds: (ids) => set((state) => ({
    activeTaskIds: typeof ids === 'function' ? ids(state.activeTaskIds) : ids,
  })),
  reset: () => set({ ...initialState }),
}));
